import PropTypes from 'prop-types'
import React from 'react'
import AuthWidget from 'components/auth/AuthWidget'
import Modal from 'components/util/Modal'
import Svg from 'components/util/Svg'
import styles from './_authModal.css'

function AuthModal (props) {
  return (
    <Modal effect='down' shouldScroll={true} {...props}>
      <div className={styles.container}>
        <AuthWidget {...props} />
        <Svg name='x' className={styles.closeButton} onClick={props.onRequestedClose} />
      </div>
    </Modal>
  )
}

AuthModal.propTypes = {
  onRequestedClose: PropTypes.func,
}

export default AuthModal
